import { useQuery } from "@tanstack/react-query";
import { getAllScoreHypo } from "../../services/scores";

const useGetScoreHypos = (id: number) => {
    return useQuery({
        queryKey: ["score-hypos", id],
        queryFn: () => getAllScoreHypo(id),
        staleTime: Infinity,
    });
}

export default useGetScoreHypos;